import React from 'react'
import Pagination, { PaginationProps } from '@material-ui/lab/Pagination'
import {
  useAppPaginationStyles,
  AppPaginationSpacing,
} from './app-pagination.styles'

export type AppPaginationProps = PaginationProps & {
  /** Outer layout: list sections, orders toolbars, or legacy inline home/moderation */
  spacing?: AppPaginationSpacing
}

export const AppPagination: React.FC<AppPaginationProps> = ({
  spacing = 'section',
  className,
  shape = 'rounded',
  color = 'primary',
  ...paginationProps
}) => {
  const classes = useAppPaginationStyles()
  const spacingClass =
    spacing === 'toolbar'
      ? classes.spacingToolbar
      : spacing === 'minimal'
        ? classes.spacingMinimal
        : classes.spacingSection

  const rootClassName = [classes.root, spacingClass, className]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={rootClassName}>
      <Pagination
        shape={shape}
        color={color}
        {...paginationProps}
      />
    </div>
  )
}
